import React, { useState, useEffect } from 'react';
import './version.css';
import { Link } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function Version() {
  const [indiaTime, setIndiaTime] = useState({ hour: '', minute: '', ampm: '' });
  const [showVersionSwitch, setShowVersionSwitch] = useState(false);

  const getTimeInIndia = () => {
    const indiaTimezone = 'Asia/Kolkata';
    const options = { timeZone: indiaTimezone, hour12: true, hour: '2-digit', minute: '2-digit'};
    const [hour, minute] = new Date().toLocaleTimeString([], options).split(/:| /);
    const ampm = new Date().toLocaleTimeString([], { timeZone: indiaTimezone, hour12: true }).split(' ')[1];
    return { hour, minute, ampm };
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const timeInIndia = getTimeInIndia();
      setIndiaTime(timeInIndia);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const toggleVersionSwitch = () => {
    setShowVersionSwitch(!showVersionSwitch);
  };

  useEffect(() => {
    if (showVersionSwitch) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'auto';
    }
  }, [showVersionSwitch]);

  return (
    <div className='version'>
      {showVersionSwitch &&(
      <div className="version-switch">
        <div className="version-switch-wrap">
          <div className="version-close">
            <div className="ver-close" onClick={toggleVersionSwitch}>
              <CloseIcon />
            </div>
          </div>
          <h2>Switch to older version?</h2>
          <div className="versions-list">
            <p>2023</p>
            <p  onClick={toggleVersionSwitch}><Link href="https://bibhu-ni-2022.netlify.app/" target="_blank" rel="noreferrer">2022</Link></p>
            <p  onClick={toggleVersionSwitch}><Link href="https://bibhu-ni-2021.netlify.app/" target="_blank" rel="noreferrer">2021</Link></p>
          </div>
        </div>
      </div>
      )}
      <div className="version-divs">
        <h2>VERSION</h2>
        <div className="version-div-bot">
          <p className='ver' onClick={toggleVersionSwitch}>2023&copy; Edition</p>
        </div>
        <h2 className="switch-version" onClick={toggleVersionSwitch}>switch</h2>
      </div>
      <div className="version-divs version-time">
        <h2>LOCAL TIME</h2>
        <p>
          <span>{indiaTime.hour}</span>:
          <span>{indiaTime.minute}</span>&nbsp;
          <span style={{ textTransform: 'uppercase' }}>{indiaTime.ampm}</span>&nbsp;GMT+5:30
        </p>
      </div>
    </div>
  )
}

export default Version;
